module.exports = __webpack_public_path__ + "static/media/ProximaNovaAlt-Semi.7063d436.ttf";